import React from "react";
import "./offlineBanner.css";

const OfflineBanner = () => (
  <div className="sr-offline-banner">
    <span>You're offline. Actions will resume when connected.</span>
  </div>
);

export default OfflineBanner;
